/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { honeyTokenContract } from "config";
import { useContractWrite, useWaitForTransaction } from "wagmi";
import { BigNumber, constants } from "ethers";
import useSnackbarRpcError from "hooks/useSnackbarRpcError";
import useCaptureRpcException from "hooks/useCaptureRpcException";

const useApproveHoney = (
  spender?: string,
  amount: BigNumber = constants.MaxUint256,
  onSuccess?: () => void
): [() => void, boolean | undefined] => {
  const [{ data, loading: isLoading, error: writeError }, approve] =
    useContractWrite(
      {
        addressOrName: honeyTokenContract.address,
        contractInterface: honeyTokenContract.interface,
      },
      "approve",
      {
        args: [spender, amount],
      }
    );

  const [{ data: waitData, loading: isWaiting, error: waitError }] =
    useWaitForTransaction({
      wait: data?.wait,
    });

  useSnackbarRpcError(writeError);
  useSnackbarRpcError(waitError);

  useCaptureRpcException(waitError);
  useCaptureRpcException(writeError);

  useEffect(() => {
    if (!isWaiting && waitData) {
      onSuccess?.();
    }
  }, [isWaiting, waitData]);

  return [approve, isLoading || isWaiting];
};

export default useApproveHoney;
